import React from "react";
import "../../styles/theme.css";
import "../../styles/HelpPage.css";

export default function ExternalApi() {
  // PDF file path (public/ folder mein hona chahiye)
  const pdfUrl = "/wh_api2.pdf";

  // PDF viewer parameters (toolbar hide karne ke liye)
  const viewerParams = "#toolbar=0&navpanes=0&pagemode=none&scrollbar=1&view=FitH&statusbar=0";

  return (
    <div className="theme-whbl" style={{ minHeight: "100vh", padding: "1.5rem" }}>
      {/* Page title */}
      <div className="text-center">
        <h2
          style={{
            color: "#f8fafc",
            fontWeight: "bold",
            margin: "0 0 1.5rem 0",
          }}
        >
          REST API Interface
        </h2>
        <a
          href={pdfUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            fontSize: "0.85rem",
            color: "#94a3b8",
            textDecoration: "underline",
            display: "inline-block",
            margin: "0 0 1.5rem 0",
            fontStyle: "italic",
          }}
        >
          Not loading?
        </a>
      </div>

      {/* PDF viewer container */}
      <div
        style={{
          width: "100%",
          maxWidth: "960px",
          margin: "0 auto",
          height: "calc(100vh - 140px)",
          border: "1px solid #334155",
          borderRadius: "12px",
          overflow: "hidden",
          background: "#0f172a",
          boxShadow: "inset 0 0 15px rgba(0,0,0,0.6)",
        }}
      >
        <iframe
          src={`${pdfUrl}${viewerParams}`}
          width="100%"
          height="100%"
          title="WhiteHaX External API Testing"
          style={{ border: "none", display: "block" }}
          allowFullScreen
        />
      </div>
    </div>
  );
}
